import { render, staticRenderFns } from "./orderYbList.vue?vue&type=template&id=67cd8572"
import script from "./orderYbList.vue?vue&type=script&lang=js"
export * from "./orderYbList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports